import * as React from "react"
import Layout from "../components/layout"

const ContactPage = () => (
  <Layout title={"Contact"}>
    <p className="text-center fs-3 ms-auto p-5">
      For general inquiries or questions about products & orders: <br />
      <a href="mailto:lol@warlockenterprises.com">lol@warlockenterprises.com</a>
    </p>
  </Layout>
)

export default ContactPage
